import './lib/bootstrap';
import Burger from './lib/burger-menu';
import submenuToggle from './lib/menu';
import initializeSliders from './lib/slider';
import inView from 'in-view';
import Aos from 'aos/dist/aos';
import mapContact from './lib/map';

document.addEventListener('DOMContentLoaded', (event) => {
  let menuTimeout;
  const closeNav = () => {
    const backdrop = document.querySelector('.Backdrop');

    $('.js-header-nav').removeClass('is-open');
    clearTimeout(menuTimeout);
    menuTimeout = setTimeout(() => {
      Burger.reverse();
      backdrop.classList.remove('Backdrop__active');
    }, 100);
  };

  const $menu = $('header .Header__nav.js-header-nav');
  $(document).mouseup((e) => {
    if ($menu.hasClass('is-open') && !$menu.is(e.target) && $menu.has(e.target).length === 0) {
      closeNav();
    }
  });

  $('.js-toggle-nav').on('click', (e) => {
    const headerNav = $('.js-header-nav');
    const backdrop = document.querySelector('.Backdrop');
    const nav = headerNav.length > 1 ? $('header .Header__nav.js-header-nav') : headerNav;

    if (!nav.hasClass('is-fixed')) {
      if (nav.hasClass('is-open')) {
        closeNav();
      } else {
        Burger.play();
        backdrop.classList.add('Backdrop__active');
        clearTimeout(menuTimeout);
        menuTimeout = setTimeout(() => nav.addClass('is-open'), 100);
      }
    }
  });

  submenuToggle();
  initializeSliders();

  if(document.querySelector('.Main__flex')) {
    let space = $('.Main__flex').data('space');

    $('.Header').attr('data-space', space);
  }

  if (document.getElementById('js-map-contact')) {
    mapContact();
  }

  Aos.init({
    disable: 'phone',
  });
  inView('.an').on('enter', (el) => { $(el).addClass('in'); });

  const headerSmall = document.querySelector('.Progress');
  window.addEventListener('scroll', () => {
    if (headerSmall) {
      const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
      const height = document.querySelector('.Main__flex-right').scrollHeight - document.documentElement.clientHeight;
      const scrolledCalc = (winScroll / height) * 100;
      const scrolled = (scrolledCalc * 445) / 100;

      if (scrolled >= 1 && winScroll < height) {
        headerSmall.style.setProperty('--height-progress', `${scrolled }px`);
      }
    }
  });

  /**
  * CONTACT FORM
  */
  function contactFormAlert($form, type, message) {
    let $alert = $form.find('.Alert');

    if ($alert.length < 1) {
      $alert = $('<div></div>');
      $form.children().first().prepend($alert);
    }

    $alert.text(message);
    $alert.removeAttr('class');
    $alert.addClass('Alert');
    $alert.addClass('m-b-15');
    $alert.addClass(`Alert--${ type}`);
    $alert.removeClass('hidden');

    $([document.documentElement, document.body]).animate({
      scrollTop: $alert.offset().top - 50,
    }, 500);
  }

  $('.js-contact-form').on('submit', (e) => {
    e.preventDefault();

    const $form = $(e.currentTarget);
    grecaptcha.ready(() => {
      grecaptcha.execute('6LcBWQwcAAAAAHGBS1tjucNN2id6yq6abGmLzB16', { action: 'submit' }).then((token) => {
        $.post(
          wp_obj.ajax_url,
          {
            action: 'stdl_submit_contact_form',
            name: $form.find('[name="name"]').val(),
            email: $form.find('[name="email"]').val(),
            phone: $form.find('[name="phone"]').val(),
            message: $form.find('[name="message"]').val(),
            captcha: token,
          },
          (response) => {
            if (response === 'success') {
              $form.trigger('reset');
              contactFormAlert($form, 'success', 'Votre message a bien été envoyé.');
            } else if (response === 'captcha') {
              contactFormAlert($form, 'error', 'Une erreur inattendue est survenue. Veuillez réessayer ultérieurement.');
            } else {
              contactFormAlert($form, 'error', 'Une erreur inattendue est survenue. Veuillez réessayer ultérieurement.');
            }
          },
        ).fail(() => {
          contactFormAlert($form, 'error', 'Error');
        });
      });
    });

    return false;
  });
});
